import React, { useEffect } from 'react';
import { UseFormSetValue, UseFormWatch } from 'react-hook-form';

import { Container } from '@common/components/container';
import { SettingsCard } from '@modules/performance/components/settings-card/settings-card';
import { RadioButton } from '@common/components/radio-button';
import { APIEvaluationForm } from '@modules/performance/types';
import { useTranslation } from 'react-i18next';
import { EvaluationFormTypes } from '@common/definitions';

export const EvaluationFormSettings = ({
  setValue,
  watch,
  currentForm,
}: {
  setValue: UseFormSetValue<any>;
  watch: UseFormWatch<any>;
  currentForm: APIEvaluationForm;
}) => {
  const { t } = useTranslation();

  const EvaluationFormTypesMap = {
    manager: {
      label: t('performance:manager'),
    },
    manager_employee: {
      label: t('performance:manager_employee'),
    },
  } as const;

  const EvaluationFormEmployeeVisibilityMap = {
    can_see_results: {
      label: t('performance:can_see_results'),
      value: true,
    },
    cannot_see_results: {
      label: t('performance:cannot_see_results'),
      value: false,
    },
  } as const;

  const getEvaluationFormTypesOptions = () => {
    return Object.entries(EvaluationFormTypesMap).map(([value, data]) => ({
      label: data.label,
      value: value as EvaluationFormTypes,
    }));
  };

  const getEvaluationFormEmployeeVisibilityOptions = () => {
    return Object.entries(EvaluationFormEmployeeVisibilityMap).map(
      ([, data]) => ({
        label: data.label,
        value: data.value,
      })
    );
  };
  const typesOptions = getEvaluationFormTypesOptions();
  const employeeVisibilityOptions =
    getEvaluationFormEmployeeVisibilityOptions();

  useEffect(() => {
    if (currentForm?.id) {
      const employeeVisibility = currentForm?.employee_visibility || false;
      const type = currentForm?.type || EvaluationFormTypes.MANAGER_EMPLOYEE;

      setTimeout(() => {
        setValue('type', type);
        setValue('settings.employeeVisibility', employeeVisibility);
      }, 0);
    }
  }, [
    currentForm?.id,
    currentForm?.employee_visibility,
    currentForm?.type,
    setValue,
  ]);

  return (
    <Container.Content className="tw-flex tw-flex-col tw-gap-6">
      <SettingsCard
        title={t('performance:type_title')}
        description={t('performance:type_description')}
      >
        {typesOptions.map((option) => (
          <div key={option.value} className="tw-flex tw-flex-row tw-gap-2">
            <RadioButton
              labelClassName="tw-text-base tw-text-inter tw-font-medium tw-text-gray-dark-900"
              label={option.label}
              value={option.value}
              currentValue={watch('type')}
              onChange={(value) => setValue('type', value)}
            />
          </div>
        ))}
      </SettingsCard>

      {watch('type') === EvaluationFormTypes.MANAGER && (
        <SettingsCard
          title={t('performance:employee_visibility_title')}
          description={t('performance:employee_visibility_description')}
        >
          {employeeVisibilityOptions.map((option) => (
            <div
              key={option.value.toString()}
              className="tw-flex tw-flex-row tw-gap-2"
            >
              <RadioButton
                labelClassName="tw-text-base tw-text-inter tw-font-medium tw-text-gray-dark-900"
                label={option.label}
                value={option.value}
                currentValue={watch('settings.employeeVisibility')}
                onChange={(value) => setValue('settings.employeeVisibility', value)}
              />
            </div>
          ))}
        </SettingsCard>
      )}

      {/* <SettingsCard
        title={t('performance:evaluation_approval_title')}
        description={t('performance:evaluation_approval_description')}
      >
        <div className="tw-flex tw-flex-row tw-gap-2">
          <Toggle value onChange={() => {}} />
          <div className="tw-text-base tw-text-inter tw-font-medium tw-text-gray-dark-900">
            {t('performance:allow_evaluation_approval')}
          </div>
        </div>
      </SettingsCard> */}

      {/* <Card>
        <Card.Content className="!tw-p-5">
          <h3>{t('forms:label_audience')}</h3>
          <div className="tw-text-gray-muted tw-text-base tw-font-medium tw-text-inter tw-mt-1 tw-mb-3">
            Decide which team members, roles, or departments can access and view
            this form.
            <br />
            Only selected users will be able to find and fill it.
          </div>
          <AudienceInputHookForm
            control={control}
            name="audience"
            organisationId="180"
            enabledFilters={[
              EPredicateFields.NETWORK,
              EPredicateFields.FUNCTION,
              EPredicateFields.LANGUAGE,
              EPredicateFields.USER,
              EPredicateFields.DAYS_IN_SERVICE,
              EPredicateFields.DAYS_BEFORE_OUT_OF_SERVICE,
            ]}
            {...planPackageAudienceHandlers}
          />
        </Card.Content>
      </Card> */}
    </Container.Content>
  );
};
